import unauthorizedByMembership from './unauthorizedByMembership'
import unauthorizedByRole from './unauthorizedByRole'

const unauthorized = {
  unauthorizedByMembership,
  unauthorizedByRole
}

export default unauthorized
